import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import classNames from "classnames";
import {
  nameOfContentSelector,
  seoOfContentSelector,
  titleOfContentSelector
} from "../../ducks/content";
import {onPlatformSelector} from "../../ducks/onPlatform";
import {scroller, Element} from "react-scroll";
import Container from "../../../common/Container";
import H from "../../../common/Typography/H";
import Button from "../../../common/Button";

import styles from "./banner.module.scss";
import banners from "../../../../mocks/banners";

function Banner({name, title, seo, onPlatform}) {
  const {h1Text, h2Text, regularTextHtml, image, buttonText} = banners[name];
  const {
    h1Text: h1TextFromAdmin,
    h2Text: h2TextFromAdmin,
    regularTextHtml: regularTextHtmlFromAdmin,
    bannerImage: bannerImageFromAdmin
  } = seo;
  const createMarkup = (__html) => ({
    __html
  });
  const scrollTo = () => {
    const isMobile = !!document.getElementById(`is-mobile`).value;
    scroller.scrollTo(`scroll-point`, {
      offset: isMobile ? -60 : 0,
      duration: 800,
      delay: 0,
      smooth: `easeInOutQuart`
    });
  };

  const srcSet =
    image.length === 1
      ? false
      : image.map((url, index) => `${url} ${++index}x`).reverse();

  return (
    <>
      <div className={classNames(styles.root, styles[`${name}Root`])}>
        <Container className={styles.container}>
          <img loading="lazy"
            srcSet={bannerImageFromAdmin || srcSet}
            src={bannerImageFromAdmin || image[0]}
            alt={title}
            className={styles.image}
          />
          <div className={styles.content}>
            <H level={1} className={styles.slogan}>
              {h1TextFromAdmin || h1Text}
            </H>
            <H level={2} className={styles.subSlogan}>
              {h2TextFromAdmin || h2Text}
            </H>
            <div
              className={styles.regularText}
              dangerouslySetInnerHTML={createMarkup(
                regularTextHtmlFromAdmin || regularTextHtml
              )}
            />
            <Button
              variant="contained"
              size="large"
              style="primary"
              className={styles.button}
              onClick={scrollTo}
              vendorStyle={onPlatform}
            >
              {buttonText}
            </Button>
          </div>
        </Container>
      </div>
      <div>
        <Container>
          <Element name="scroll-point" />
          <H
            level={3}
            className={classNames(styles.title, {
              [styles.titleVTB]: onPlatform === `vtb`
            })}
          >
            Онлайн-конструктор одежды с принтом
          </H>
          <H level={1} className={styles.mSlogan}>
            {h1TextFromAdmin || h1Text}
          </H>
        </Container>
      </div>
    </>
  );
}

Banner.propTypes = {
  name: PropTypes.string,
  title: PropTypes.string,
  seo: PropTypes.shape({
    h1Text: PropTypes.string,
    h2Texth1Text: PropTypes.string,
    regularTextHtmlh1Text: PropTypes.string,
    bannerImage: PropTypes.string
  }),
  onPlatform: PropTypes.string
};

const mapStateToProps = (state) => ({
  name: nameOfContentSelector(state),
  title: titleOfContentSelector(state),
  seo: seoOfContentSelector(state),
  onPlatform: onPlatformSelector(state)
});

export default connect(mapStateToProps)(Banner);
